/* eslint-disable prettier/prettier */
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { JWT_TOKEN } from './config';
import './scss/style.scss';
import { countriesAPIAction, statesAPIAction } from './store/actions/countriesApiAction';
import {
  levelIncomeAction,
  rewardIncomeAction,
  taskIncomeAction
} from './store/actions/incomeActions';
import { myLeadAction } from './store/actions/leadActions';
import { levelPointAction, rewardPointAction, taskPointAction } from './store/actions/pointAction';
import { myTeamActions, teamRefferalActions } from './store/actions/teamActions';
import { withdrawAction } from './store/actions/withdrawAction';
import Chat from './views/chats/Chat';
import Info from './views/user/pages/task/Info';
const loading = (
  <Box sx={{ width: "30%", margin: "auto", transform: "translate(5%,90%)", height: "50vh" }}>
    <LinearProgress sx={{color: "#321fdb"}} />
  </Box>
)
// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
const FrontPage = React.lazy(() => import('./views/user/pages/frontpage/FrontPage'))
const Login = React.lazy(() => import('./views/user/pages/login/Login'))
const Register = React.lazy(() => import('./views/user/pages/register/Register'))
const ForgotPassword = React.lazy(() => import('./views/user/pages/forgotpassword/ForgotPassword'))
const ResetPassword = React.lazy(() => import('./views/user/pages/resetpassword/ResetPassword'))
const Page404 = React.lazy(() => import('./views/user/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/user/pages/page500/Page500'))

const App = () => {
  // redux hooks
  const dispatch = useDispatch()
  // axios headers
  const tokenData = useSelector((state) => state.login.data)

  // config function
  const configFunc = (paramsObj) => {
    return {
      headers: {
        'x-auth-token': (JWT_TOKEN && JWT_TOKEN) || (tokenData && tokenData?.token),
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
      params: paramsObj,
    }
  }
  useEffect(() => {
    dispatch(myTeamActions(configFunc()))
    dispatch(teamRefferalActions(configFunc()))
    dispatch(levelIncomeAction(configFunc()))
    dispatch(rewardIncomeAction(configFunc()))
    dispatch(taskIncomeAction(configFunc({ txn_type: 'taskincome' })))
    dispatch(levelPointAction(configFunc({ txn_type: 'referralpoint' })))
    dispatch(rewardPointAction(configFunc()))
    dispatch(taskPointAction(configFunc({ txn_type: 'taskpoint' })))
    dispatch(withdrawAction(configFunc()))
    dispatch(myLeadAction(configFunc()))
  }, [dispatch, JWT_TOKEN, tokenData?.token])
  useEffect(() => {
    dispatch(countriesAPIAction())
    dispatch(statesAPIAction())
  }, [])
  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <ToastContainer />
        <Switch>
          {/* <Route exact path="/" name="Home" render={(props) => <Page404 {...props} />} /> */}
          {/* <Route path="/user" name="Home" render={(props) => <DefaultLayout {...props} />} /> */}

          <Route
            exact
            path="/user/login"
            name="Login Page"
            render={(props) => <Login {...props} />}
          />

          <Route exact path="/chats" name="Chat Page" render={(props) => <Chat {...props} />} />
          <Route exact path="/" name="Front Page" render={(props) => <FrontPage {...props} />} />
          <Route
            exact
            path="/user/forgotpassword"
            name="Forgot Password Page"
            render={(props) => <ForgotPassword {...props} />}
          />
          <Route
            exact
            path="/user/resetpassword/:token"
            name="Reset Password Page"
            render={(props) => <ResetPassword {...props} />}
          />

          <Route
            exact
            path="/user/register"
            name="Register Page"
            render={(props) => <Register {...props} />}
          />
          <Route
            exact
            path={`/register`}
            name="Register Page"
            render={(props) => <Register {...props} />}
          />
          <Route
            exact
            path="/user/register/:sponsorid"
            name="Register Page"
            render={(props) => <Register {...props} />}
          />

          <Route
            exact
            path="/user/task/info/:id"
            name="Info"
            render={(props) => <Info {...props} />}
          />
          {/* <Route exact path="/user/task/approve" name="ApproveAns" render={(props) => <ApproveAnswer {...props} />} /> */}

          <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
          <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
          <Route path="/user" name="Home2" render={(props) => <DefaultLayout {...props} />} />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  )
}

export default App
